import { useContext, useEffect, useState } from 'react';
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import TopLoadingBar from '../topLoadingBar/topLoadingBar';
import { Notes_List_Details } from '../../api/NoteApi/NoteApi';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { ERROR_CODE } from '../../constant';
import LogOut from '../../utils/logout';
import { useNavigate } from 'react-router';
import AccommodationContext from '../../context/AccommodationContext/AccommodationContext';
import { Accommodation_List } from '../../api/AccommodationApi/AccommodationApi';
import AccommodationBookingList from './AccommodationItem';

const Accommodation = () => {
  const {
    setformvalue,
    setahoeDataModel,
    setModal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    filter,
    setFilter,
    progress,
    setProgress,
    setToggle,
    setShowNote,
    setNoteId,
    filterOrderId,
    startDate,
    endDate,
    dateField
  } = useContext(AccommodationContext);
  const { loaderShow, setLoaderShow, responseLoader, setResponseLoader } = useContext(OrganizationContext);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const history = useNavigate();

  /**
   * Accommodation_List List api call function and useEffect use to call function
   */

  const getData = async () => {
    setResponseLoader(!responseLoader);
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy
      };
      const activeFilters = Object.fromEntries(Object.entries(filter).filter(([_, v]) => v));
      paramsObj['search'] = activeFilters;
      if (startDate) {
        paramsObj['search'] = { ...paramsObj['search'], start: startDate };
      }
      if (endDate) {
        paramsObj['search'] = { ...paramsObj['search'], end: endDate };
      }
      if (dateField) {
        paramsObj['search'] = { ...paramsObj['search'], dateField };
      }
      // if (filter) {
      //   console.log('filter >> ', filter);
      //   paramsObj['search'] = { mobile: filter };
      // }
      // if (filterOrderId) {
      //   console.log('filterOrderId >> ', filterOrderId);
      //   paramsObj['search'] = { razorpay_order_id: filterOrderId };
      // }
      const { data } = await Accommodation_List(paramsObj);
      if (data.status === 200) {
        setformvalue(data.payload.data);
        setRecord(data.pager.totalRecords);
        setResponseLoader(false);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      setResponseLoader(false);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  useEffect(() => {
    getData();
    setProgress(100);
  }, [page, pageSize, sortOrder, sortBy, filter, filterOrderId, startDate, endDate, dateField]);

  /**
   * Add donation master model open function call
   */

  const AddModel = () => {
    setModal(true);
    setToggle(true);
  };

  /**
   * Show donation master api call funtion call
   */

  const showHandle = async (noteId) => {
    setNoteId(noteId);
    setLoaderShow(!loaderShow);
    try {
      const { data } = await Notes_List_Details(noteId);
      if (data.status === 200) {
        setShowNote(data.payload.data);
        setLoaderShow(false);
        setahoeDataModel(true);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error.response, {
        autoClose: 1000,
        transition: Zoom
      });
      setLoaderShow(false);
    }
  };

  /**
   * sorting funcion call
   */

  const sorting = (col) => {
    if (sortOrder === '') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('ASC');
    }
    if (sortOrder === 'ASC') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('DSC');
    }
    if (sortOrder === 'DSC') {
      setSortBy();
      setSortOrder('');
    }
  };

  /**
   * Search function call
   */
  const handleFilter = (e) => {
    if (e.target.value === '') {
      setFilter(e.target.value);
    } else {
      setFilter(e.target.value);
    }
  };

  /**
   * Model Close Function
   */

  return (
    <>
      <div>
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <AccommodationBookingList
          handleFilter={handleFilter}
          sorting={sorting}
          showHandle={showHandle}
          AddModel={AddModel}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
          getData={getData}
        />
      </div>
    </>
  );
};
export default Accommodation;
